var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"fill":"currentColor","d":"M21.831 10.498L19.833 8.5 11.333 17 19.833 25.5 21.831 23.503 15.342 17z","transform":"translate(-163 -136) translate(163 136)","key":0}),React.createElement("path",{"d":"M0 0L34 0 34 34 0 34z","transform":"translate(-163 -136) translate(163 136)","key":1})]))));
}

ChevronLeft.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
